// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qcnyv","colMin":"styles_colMin__ZmkmJ"};